import React from "react";
import MapContext from "./MapContext";
import { Map } from "mapbox-gl";

interface MapProviderProps {
  accessToken: string;
  map: Map | null;
  setMap: React.Dispatch<React.SetStateAction<any>>;
}

const MapProvider: React.FC<MapProviderProps> = ({
  accessToken,
  map,
  setMap,
  children,
}) => {
  return (
    <MapContext.Provider value={{ accessToken, map, setMap }}>
      {children}
    </MapContext.Provider>
  );
};

export default MapProvider;
